import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { ErrorDatabaseResponse } from '../../../projects/client';

import { ActiveDeviceError } from './error-details.model';

export namespace ErrorDetailsActions {
  export const getErrorDetails = createActionGroup({
    source: 'ERROR DETAILS Get Error Details',
    events: {
      attempt: props<{
        materialNumber: string;
        errorCode: string;
        countryCode: string;
        languageCode: string;
      }>(),
      success: props<{
        existingErrors: ActiveDeviceError | ErrorDatabaseResponse;
      }>(),
      failed: props<{ error: any }>(),
    },
  });

  export const getAllErrorsDetails = createActionGroup({
    source: 'ERROR DETAILS Get All Error Details',
    events: {
      attempt: props<{
        materialNumber: string;
        countryCode: string;
        languageCode: string;
      }>(),
      success: props<{
        errors: ErrorDatabaseResponse;
      }>(),
      failed: props<{ error: any }>(),
      aborted: emptyProps(),
    },
  });

  export const clearState = createAction('ERROR DETAILS Clear State');
}
